/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
// import Icon from "@mui/material/Icon";
import { Button, Tooltip } from "@mui/material";
import SoftButton from "components/SoftButton";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useState, useEffect } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Checkbox, FormControlLabel } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import FearGreedIndexComponent from "./FearGreedIndexComponent";
import InfoIcon from "@mui/icons-material/Info";
//images
import IconLeft from "../../../assets/images/IconLeft.png";
import IconRight from "../../../assets/images/IconRight.png";
import IconMiddle from "../../../assets/images/IconMiddle.png";
import ClockIcon from "../../../assets/images/clock.gif";
import direction from "../../../assets/images/confidence.gif";
import Effort from "../../../assets/images/red.gif";
import lackMoney from "../../../assets/images/money.gif";
// import wrenchImg from "../../../assets/images/wrench.png";
// import cryptoImg from "../../../assets/images/crypto.png";
// import rocketImg from "../../../assets/images/rocket.png";

// Soft UI Dashboard PRO React components
// import SoftBox from "components/SoftBox";
// import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
// import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
// import SalesTable from "examples/Tables/SalesTable";
// import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
// import GradientLineChart from "examples/Charts/LineCharts/GradientLineChart";
// import Globe from "examples/Globe";

// Soft UI Dashboard PRO React base styles
// import typography from "assets/theme/base/typography";
// import breakpoints from "assets/theme/base/breakpoints";

// Data
// import salesTableData from "layouts/dashboards/default/data/salesTableData";
// import reportsBarChartData from "layouts/dashboards/default/data/reportsBarChartData";
// import gradientLineChartData from "layouts/dashboards/default/data/gradientLineChartData";
import { getFearIndex } from "layouts/applications/data-tables/data/getData";
// import { useSoftUIController } from "context";
import { getFinnhubNews } from "layouts/applications/data-tables/data/getData";
import { NewsTable } from "components/CustomComponents";
import { DashboardInfoPopup } from "components/CustomPopups/InfoPopups";
import EconomicCalendar from "components/Widgets/EconomicCalendar";
import SmallSymbolOverviewWidget from "components/etc/SmallSymbolOverviewWidget";
import KeyYearEvents from "./components/KeyYearEvents";
import SoftBox from "components/SoftBox";
// import { DashboardInfoPopup } from "components/InfoPopups";
import SeasonalityBlock from "./components/Seasonality";

function Default() {
  // const { values } = breakpoints;
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [defensiveSectors, setDefensiveSectors] = useState([
    {
      name: "Communication Services (XLC)",
      exchange: "AMEX",
      Ticker: "XLC",
    },
    {
      name: "Consumer Staples (XLP)",
      exchange: "AMEX",
      Ticker: "XLP",
    },
  ]);
  const [cyclicalSectors, setCyclicalSectors] = useState([
    {
      name: "Consumer Discretionary (XLY)",
      exchange: "AMEX",
      Ticker: "XLY",
    },
    {
      name: "Financials (XLF)",
      exchange: "AMEX",
      Ticker: "XLF",
    },
  ]);
  // const { size } = typography;
  // const { chart, items } = reportsBarChartData;
  // const [controller] = useSoftUIController();
  // const { sidenavColor } = controller;
  const [exchange, setExchange] = useState("1T HOF");
  const [newsCategory, setNewsCategory] = useState("general");
  const [newsData, setNewsData] = useState([]);
  const [infoPopup, toggleInfoPopup] = useState(false);
  const [popupAccessor, setPopupAccessor] = useState("");

  const [fearData, setFearData] = useState({
    lastUpdated: {
      epochUnixSeconds: 0,
      humanDate: "2023-02-10T01:00:00.000Z",
    },
    fgi: {
      now: {
        value: 0,
        valueText: "Greed",
      },
      previousClose: {
        value: 0,
        valueText: "Greed",
      },
      oneWeekAgo: {
        value: 0,
        valueText: "Extreme Greed",
      },
      oneMonthAgo: {
        value: 0,
        valueText: "Neutral",
      },
      oneYearAgo: {
        value: 0,
        valueText: "Fear",
      },
    },
  });
  useEffect(() => {
    handleFear();
    handleNews("general");
  }, []);

  const handleNews = async (currCategory) => {
    let fetchedNews;
    fetchedNews = await getFinnhubNews(currCategory);
    setNewsData(fetchedNews);
  };

  const handleFear = async () => {
    let fearData;
    fearData = await getFearIndex();

    if (fearData !== null) {
      setFearData(fearData);
    }
  };

  const handleInfoPop = (popupAccessor) => {
    console.log("pressed");
    toggleInfoPopup(true);
    setPopupAccessor(popupAccessor);
  };
  function BasicMenu(type) {
    // console.log(type)
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    let currentData;
    if (type.type === "defensive") {
      currentData = sector_defensive;
    } else {
      currentData = sector_cyclical;
    }

    return (
      <div>
        <Button
          className="sectorButtons greyDropdown"
          id="basic-button"
          variant="contained"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          style={{ width: "80%", marginBottom: "10px", maxWidth: "190px" }}
        >
          {type.type === "defensive" ? "SECTOR DEFENSIVE" : "SECTOR CYCLICAL"}
          <KeyboardArrowDownIcon style={{ marginLeft: "6px" }}></KeyboardArrowDownIcon>
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {currentData.map((sector, index) => {
            const found = checkSector(sector, type.type);
            return (
              <div key={index}>
                <MenuItem>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={found}
                        onChange={(event) => {
                          handleCheckbox(event, sector, type.type);
                        }}
                      />
                    }
                    label={sector.name}
                  />{" "}
                </MenuItem>
              </div>
            );
          })}
        </Menu>
      </div>
    );
  }

  const configureHTML = () => {
    if (exchange === "1T HOF") {
      return hof;
    } else if (exchange === "Indices") {
      return indicesHTML;
    } else if (exchange === "MONEY") {
      return moneyHTML;
    } else if (exchange === "CRYPTO") {
      return cryptoHTML;
    }
    return commodityHTML;
  };
  const sector_defensive = [
    {
      name: "Communication Services (XLC)",
      exchange: "AMEX",
      Ticker: "XLC",
    },
    {
      name: "Consumer Staples (XLP)",
      exchange: "AMEX",
      Ticker: "XLP",
    },
    {
      name: "Energy (XLE)",
      exchange: "AMEX",
      Ticker: "XLE",
    },
    {
      name: "Health Care (XLV)",
      exchange: "AMEX",
      Ticker: "XLV",
    },
    {
      name: "Utilities (XLU)",
      exchange: "AMEX",
      Ticker: "XLU",
    },
  ];
  const sector_cyclical = [
    {
      name: "Consumer Discretionary (XLY)",
      exchange: "AMEX",
      Ticker: "XLY",
    },
    {
      name: "Financials (XLF)",
      exchange: "AMEX",
      Ticker: "XLF",
    },
    {
      name: "Industrials (XLI)",
      exchange: "AMEX",
      Ticker: "XLI",
    },
    {
      name: "Materials (XLB)",
      exchange: "AMEX",
      Ticker: "XLB",
    },
    {
      name: "Real Estate (XLRE)",
      exchange: "AMEX",
      Ticker: "XLRE",
    },
    {
      name: "Technology (XLK)",
      exchange: "AMEX",
      Ticker: "XLK",
    },
  ];

  // const sectorData = [
  // 	{
  // 		name: "Communication Services (XLC)",
  // 		exchange: "AMEX",
  // 		Ticker: "XLC",
  // 	},
  // 	{
  // 		name: "Consumer Discretionary (XLY)",
  // 		exchange: "AMEX",
  // 		Ticker: "XLY",
  // 	},
  // 	{
  // 		name: "Consumer Staples (XLP)",
  // 		exchange: "AMEX",
  // 		Ticker: "XLP",
  // 	},
  // 	{
  // 		name: "Energy (XLE)",
  // 		exchange: "AMEX",
  // 		Ticker: "XLE",
  // 	},
  // 	{
  // 		name: "Financials (XLF)",
  // 		exchange: "AMEX",
  // 		Ticker: "XLF",
  // 	},
  // 	{
  // 		name: "Health Care (XLV)",
  // 		exchange: "AMEX",
  // 		Ticker: "XLV",
  // 	},
  // 	{
  // 		name: "Materials (XLB)",
  // 		exchange: "AMEX",
  // 		Ticker: "XLB",
  // 	},
  // 	{
  // 		name: "Real Estate (XLRE)",
  // 		exchange: "AMEX",
  // 		Ticker: "XLRE",
  // 	},
  // 	{
  // 		name: "Technology (XLK)",
  // 		exchange: "AMEX",
  // 		Ticker: "XLK",
  // 	},
  // 	{
  // 		name: "Utilities (XLU)",
  // 		exchange: "AMEX",
  // 		Ticker: "XLU",
  // 	},
  // ];

  const checkSector = (sector, type) => {
    const sectorName = sector.name;
    let currentSectors;
    if (type === "defensive") {
      currentSectors = defensiveSectors;
    } else {
      currentSectors = cyclicalSectors;
    }
    const found = currentSectors.find((element) => {
      if (element.name === sectorName) {
        return true;
      } else {
        return false;
      }
    });
    return found ? true : false;
  };
  const handleCheckbox = (event, sectorData, type) => {
    const isChecked = event.target.checked;
    const name = sectorData.name;
    if (name && isChecked) {
      if (type === "defensive") {
        const sectorsUpdated = [...defensiveSectors, sectorData];
        setDefensiveSectors(sectorsUpdated);
      } else {
        const sectorsUpdated = [...cyclicalSectors, sectorData];
        setCyclicalSectors(sectorsUpdated);
      }

      // scroll it to the top of section
      setTimeout(() => {
        const elem = document.getElementById(`${type}-sectors-${sectorData.ticker}`);
        const topPos = elem.offsetTop;
        const containerDiv = document.getElementById(`${type}-sectors`);
        containerDiv.scrollTop = topPos;
      }, 500);

      return;
    } else if (name && !isChecked) {
      if (type === "defensive") {
        setDefensiveSectors(defensiveSectors.filter((sector) => sector.name !== name));
      } else {
        setCyclicalSectors(cyclicalSectors.filter((sector) => sector.name !== name));
      }

      return;
    }
  };
  const SectorButtons = () => {
    let className = "sectorButtons";
    return (
      <div className={className}>
        <SoftButton
          onClick={() => {
            setExchange("Indices");
          }}
          className={exchange === "Indices" ? "greyDropdown" : "blackText"}
          variant={exchange !== "Indices" ? "text" : "contained"}
        >
          Indices
        </SoftButton>
        <SoftButton
          onClick={() => {
            setExchange("COMMODITY");
          }}
          className={exchange === "COMMODITY" ? "greyDropdown" : "blackText"}
          variant={exchange !== "COMMODITY" ? "text" : "contained"}
        >
          COMMODITY
        </SoftButton>
        <SoftButton
          onClick={() => {
            setExchange("MONEY");
          }}
          className={exchange === "MONEY" ? "greyDropdown" : "blackText"}
          variant={exchange !== "MONEY" ? "text" : "contained"}
        >
          MONEY
        </SoftButton>
        <SoftButton
          onClick={() => {
            setExchange("CRYPTO");
          }}
          className={exchange === "CRYPTO" ? "greyDropdown" : "blackText"}
          variant={exchange !== "CRYPTO" ? "text" : "contained"}
        >
          Crypto
        </SoftButton>
        <SoftButton
          onClick={() => {
            setExchange("1T HOF");
          }}
          className={exchange === "1T HOF" ? "greyDropdown" : "blackText"}
          variant={exchange !== "1T HOF" ? "text" : "contained"}
        >
          1T HOF
        </SoftButton>
      </div>
    );
  };

  const NewsButtons = () => {
    let className = "sectorButtons";
    return (
      <div className={className}>
        <SoftButton
          onClick={() => {
            setNewsCategory("general");
            handleNews("general");
          }}
          className={newsCategory === "general" ? "greyDropdown" : "blackText"}
          variant={newsCategory !== "general" ? "text" : "contained"}
        >
          General
        </SoftButton>
        <SoftButton
          onClick={() => {
            setNewsCategory("forex");
            handleNews("forex");
          }}
          className={newsCategory === "forex" ? "greyDropdown" : "blackText"}
          variant={newsCategory !== "forex" ? "text" : "contained"}
        >
          Forex
        </SoftButton>
        <SoftButton
          onClick={() => {
            setNewsCategory("merger");
            handleNews("merger");
          }}
          className={newsCategory === "merger" ? "greyDropdown" : "blackText"}
          variant={newsCategory !== "merger" ? "text" : "contained"}
        >
          Merger
        </SoftButton>
      </div>
    );
  };

  const sectorHTML = (exchange, ticker) => {
    return `<!-- TradingView Widget BEGIN -->
	<div class="tradingview-widget-container">
	  <div id="tradingview_fb944"></div>
	
	  <script type="text/javascript" src="https://s3.tradingview.com/tv.js"></script>
	  <script type="text/javascript">
	  new TradingView.MediumWidget(
	  {
	  "symbols": [
		[
		  " ${exchange}:${ticker}| 12M"
		]
	  ],
	  "chartOnly": true,
	  "width": "100%",
	  "height": "130",
	  "locale": "en",
	  "colorTheme": "light",
	  "gridLineColor": "rgba(42 ,46, 57, 0)",
	  "fontColor": "#787B86",
	  "isTransparent": false,
	  "autosize": true,
	  "showVolume": false,
	  "scalePosition": "no",
	  "scaleMode": "Normal",
	  "fontFamily": "-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif",
	  "noTimeScale": false,
	  "valuesTracking": "1",
	  "chartType": "line",
	  "container_id": "tradingview_fb944"
	}
	  );
	  </script>
	</div>
	<!-- TradingView Widget END -->`;
  };

  const moneyHTML = `<!-- TradingView Widget BEGIN -->
	<div class="tradingview-widget-container">
	  <div class="tradingview-widget-container__widget"></div>
	  <script type="text/javascript" src="https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js" async>
	  {
	  "colorTheme": "light",
	  "dateRange": "12M",
	  "showChart": true,
	  "locale": "en",
	  "largeChartUrl": "",
	  "isTransparent": false,
	  "showSymbolLogo": true,
	  "showFloatingTooltip": false,
	  "width": "100%",
  	  "height": "400",
	  "plotLineColorGrowing": "rgba(41, 98, 255, 1)",
	  "plotLineColorFalling": "rgba(41, 98, 255, 1)",
	  "gridLineColor": "rgba(240, 243, 250, 0)",
	  "scaleFontColor": "rgba(106, 109, 120, 1)",
	  "belowLineFillColorGrowing": "rgba(41, 98, 255, 0.12)",
	  "belowLineFillColorFalling": "rgba(41, 98, 255, 0.12)",
	  "belowLineFillColorGrowingBottom": "rgba(41, 98, 255, 0)",
	  "belowLineFillColorFallingBottom": "rgba(41, 98, 255, 0)",
	  "symbolActiveColor": "rgba(41, 98, 255, 0.12)",
	  "tabs": [
		{
		  "title": "Bonds",
		  "symbols": [
			  {
          "s": "NASDAQ:TLT",
          "d": "iShares 20Y Treasury Bond ETF",
          "logoid": "ishares",
          "currency-logoid": "country/US"
        },
        {
          "s": "AMEX:TLH",
          "d": "iShares 10-20Y Treasury Bond ETF",
          "logoid": "ishares",
          "currency-logoid": "country/US"
        },
        {
          "s": "NASDAQ:IEF",
          "d": "iShares 3-7Y Treasury Bond ETF",
          "logoid": "ishares",
          "currency-logoid": "country/US"
        },
        {
          "s": "NASDAQ:SHY",
          "d": "iShares 1-3Y Treasury Bond ETF",
          "logoid": "ishares",
          "currency-logoid": "country/US"
        }
		  ],
		  "originalTitle": "Bonds"
		},
		{
		  "title": "Forex (major)",
		  "symbols": [
        {
          "s": "FX:EURUSD",
          "d": "EUR to USD"
        },
        {
          "s": "FX:GBPUSD",
          "d": "GBP to USD"
        },
        {
          "s": "FX:USDJPY",
          "d": "USD to JPY"
        },
        {
          "s": "FX:USDCHF",
          "d": "USD to CHF"
        },
        {
          "s": "FX:AUDUSD",
          "d": "AUD to USD"
        },
        {
          "s": "FX:USDCAD",
          "d": "USD to CAD"
        },
        {
          "s": "FX:NZDUSD",
          "d": "NZD to USD",
          "base-currency-logoid": "country/NZ",
          "currency-logoid": "country/US"
        }
      ],
		  "originalTitle": "Forex"
		},
    {
		  "title": "Forex (minor)",
		  "symbols": [
        {
          "s": "TICKMILL:EURGBP",
          "d": "EUR to GBP",
          "base-currency-logoid": "country/EU",
          "currency-logoid": "country/GB"
        },
        {
          "s": "FX:EURCHF",
          "d": "EUR to CHF",
          "base-currency-logoid": "country/EU",
          "currency-logoid": "country/CH"
        },
        {
          "s": "FX:EURJPY",
          "d": "EUR to JPY",
          "base-currency-logoid": "country/EU",
          "currency-logoid": "country/JP"
        },
        {
          "s": "FX:GBPJPY",
          "d": "GBP to JPY",
          "base-currency-logoid": "country/GB",
          "currency-logoid": "country/JP"
        },
        {
          "s": "FX:GBPCHF",
          "d": "GBP to CHF",
          "base-currency-logoid": "country/GB",
          "currency-logoid": "country/CH"
        },
        {
          "s": "FX:GBPAUD",
          "d": "GBP to AUD",
          "base-currency-logoid": "country/GB",
          "currency-logoid": "country/AU"
        },
        {
          "s": "FX:CADJPY",
          "d": "CAD to JPY",
          "base-currency-logoid": "country/CA",
          "currency-logoid": "country/JP"
        }
      ],
		  "originalTitle": "Forex Minor"
		}
	  ]
	}
	  </script>
	</div>
	<!-- TradingView Widget END -->`;

  const cryptoHTML = `<!-- TradingView Widget BEGIN -->
	<div class="tradingview-widget-container">
	  <div class="tradingview-widget-container__widget"></div>
	  <script type="text/javascript" src="https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js" async>
	  {
	  "colorTheme": "light",
	  "dateRange": "12M",
	  "showChart": true,
	  "locale": "en",
	  "largeChartUrl": "",
	  "isTransparent": false,
	  "showSymbolLogo": true,
	  "showFloatingTooltip": false,
	  "width": "100%",
  	  "height": "400",
	  "plotLineColorGrowing": "rgba(41, 98, 255, 1)",
	  "plotLineColorFalling": "rgba(41, 98, 255, 1)",
	  "gridLineColor": "rgba(240, 243, 250, 0)",
	  "scaleFontColor": "rgba(106, 109, 120, 1)",
	  "belowLineFillColorGrowing": "rgba(41, 98, 255, 0.12)",
	  "belowLineFillColorFalling": "rgba(41, 98, 255, 0.12)",
	  "belowLineFillColorGrowingBottom": "rgba(41, 98, 255, 0)",
	  "belowLineFillColorFallingBottom": "rgba(41, 98, 255, 0)",
	  "symbolActiveColor": "rgba(41, 98, 255, 0.12)",
	  "tabs": [
		{
		  "title": "Crypto",
		  "symbols": [
			{
			  "s": "BITSTAMP:BTCUSD"
			},
			{
			  "s": "BITSTAMP:ETHUSD"
			},
			{
			  "s": "CRYPTO:BNBUSD"
			},
			{
			  "s": "BITSTAMP:SOLUSD"
			},
			{
			  "s": "BITSTAMP:XRPUSD"
			},
			{
			  "s": "BITSTAMP:ADAUSD"
			},
			{
			  "s": "BITSTAMP:DOGEUSD"
			}
		  ]
		}
	  ]
	}
	  </script>
	</div>
	<!-- TradingView Widget END -->`;

  const commodityHTML = `
	<!-- TradingView Widget BEGIN -->
<div class="tradingview-widget-container">
  <div class="tradingview-widget-container__widget"></div>
  <script type="text/javascript" src="https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js" async>
  {
  "colorTheme": "light",
  "dateRange": "12M",
  "showChart": true,
  "locale": "en",
  "width": "100%",
  "height": "400",
  "largeChartUrl": "",
  "isTransparent": false,
  "showSymbolLogo": true,
  "showFloatingTooltip": false,
  "plotLineColorGrowing": "rgba(41, 98, 255, 1)",
  "plotLineColorFalling": "rgba(41, 98, 255, 1)",
  "gridLineColor": "rgba(240, 243, 250, 0)",
  "scaleFontColor": "rgba(120, 123, 134, 1)",
  "belowLineFillColorGrowing": "rgba(41, 98, 255, 0.12)",
  "belowLineFillColorFalling": "rgba(41, 98, 255, 0.12)",
  "belowLineFillColorGrowingBottom": "rgba(41, 98, 255, 0)",
  "belowLineFillColorFallingBottom": "rgba(41, 98, 255, 0)",
  "symbolActiveColor": "rgba(41, 98, 255, 0.12)",
  "tabs": [
    {
      "title": "Commodities",
      "symbols": [
        {
          "s": "CMCMARKETS:GOLD",
          "d": "Gold"
        },
        {
          "s": "CMCMARKETS:SILVERK2026",
          "d": "SILVER"
        },
        {
          "s": "CMCMARKETS:COPPERK2026",
          "d": "COPPER"
        },
        {
          "s": "CMCMARKETS:CORNK2026",
          "d": "CORN"
        },
        {
          "s": "TVC:USOIL",
          "d": "WTI Crude Oil",
          "logoid": "crude-oil",
          "currency-logoid": "country/US"
        }
      ],
      "originalTitle": "Futures"
    }
  ]
}
  </script>
</div>
<!-- TradingView Widget END -->
	`;
  const indicesHTML = `
	<!-- TradingView Widget BEGIN -->
<div class="tradingview-widget-container">
  <div class="tradingview-widget-container__widget"></div>
  <script type="text/javascript" src="https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js" async>
  {
  "colorTheme": "light",
  "dateRange": "12M",
  "showChart": true,
  "locale": "en",
  "width": "100%",
  "height": "400",
  "largeChartUrl": "",
  "isTransparent": false,
  "showSymbolLogo": true,
  "showFloatingTooltip": false,
  "plotLineColorGrowing": "rgba(41, 98, 255, 1)",
  "plotLineColorFalling": "rgba(41, 98, 255, 1)",
  "gridLineColor": "rgba(240, 243, 250, 0)",
  "scaleFontColor": "rgba(120, 123, 134, 1)",
  "belowLineFillColorGrowing": "rgba(41, 98, 255, 0.12)",
  "belowLineFillColorFalling": "rgba(41, 98, 255, 0.12)",
  "belowLineFillColorGrowingBottom": "rgba(41, 98, 255, 0)",
  "belowLineFillColorFallingBottom": "rgba(41, 98, 255, 0)",
  "symbolActiveColor": "rgba(41, 98, 255, 0.12)",
  "tabs": [
    {
      "title": "Market Indices (US)",
      "symbols": [
        {
          "s": "FOREXCOM:SPXUSD",
          "d": "S&P 500"
        },
        {
          "s": "FOREXCOM:DJI",
          "d": "Dow 30"
        },
        {
          "s": "FXOPEN:NDQM",
          "d": "Nasdaq Composite"
        },
        {
          "s": "CAPITALCOM:RTY",
          "d": "Russell 2000 Index"
        },
        {
          "s": "PEPPERSTONE:VIX",
          "d": "Volatility Index"
        }
      ],
      "originalTitle": "Indices"
    },
    {
      "title": "Market Indices (Key Mkts)",
      "symbols": [
        {
          "s": "CAPITALCOM:J225",
          "d": "Nikkei 225 Japan"
        },
        {
          "s": "SSE:000001",
          "d": "SSE Composite Index China"
        },
        {
          "s": "HSI:HSI",
          "d": "Hang Seng Index Hong Kong"
        },
        {
          "s": "XETR:DAX",
          "d": "DAX Index Germany"
        },
        {
          "s": "FOREXCOM:UKXGBP",
          "d": "FTSE 100 Index United Kingdom"
        }
      ]
    },
    {
      "title": "Market Index (ASEAN)",
      "symbols": [
        {
          "s": "INDEX:STI",
          "d": "Straits Times Index Singapore"
        },
        {
          "s": "INDEX:KLSE",
          "d": "FTSE Bursa Malaysia KLCI"
        },
        {
          "s": "BSE:SENSEX",
          "d": "BSE Sensex India"
        }
      ]
    }
  ]
}
  </script>
</div>
<!-- TradingView Widget END -->
	`;
  const hof = `<!-- TradingView Widget BEGIN -->
	<div class="tradingview-widget-container">
	  <div class="tradingview-widget-container__widget"></div>
	  <script type="text/javascript" src="https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js" async>
	  {
	  "colorTheme": "light",
	  "dateRange": "12M",
	  "showChart": true,
	  "locale": "en",
	  "width": "100%",
	  "height": "400",
	  "largeChartUrl": "",
	  "isTransparent": false,
	  "showSymbolLogo": true,
	  "showFloatingTooltip": false,
	  "plotLineColorGrowing": "rgba(41, 98, 255, 1)",
	  "plotLineColorFalling": "rgba(41, 98, 255, 1)",
	  "gridLineColor": "rgba(240, 243, 250, 0)",
	  "scaleFontColor": "rgba(120, 123, 134, 1)",
	  "belowLineFillColorGrowing": "rgba(41, 98, 255, 0.12)",
	  "belowLineFillColorFalling": "rgba(41, 98, 255, 0.12)",
	  "belowLineFillColorGrowingBottom": "rgba(41, 98, 255, 0)",
	  "belowLineFillColorFallingBottom": "rgba(41, 98, 255, 0)",
	  "symbolActiveColor": "rgba(41, 98, 255, 0.12)",
	  "tabs": [
		{
		  "title": "1T Hall of Fame LIST",
		  "symbols": [
			{
			  "s": "NASDAQ:NVDA",
			  "d": "Nvida"
			},
			{
			  "s": "NASDAQ:AAPL",
			  "d": "Apple Inc."
			},
			{
			  "s": "NASDAQ:MSFT",
			  "d": "Microsoft"
			},
			{
			  "s": "NASDAQ:GOOG",
			  "d": "Alphabet (Google)"
			},
			{
			  "s": "NASDAQ:AMZN",
			  "d": "Amazon"
			},
			{
			  "s": "NASDAQ:META",
			  "d": "META"
			},
			{
			  "s": "NASDAQ:TSLA",
			  "d": "Tesla"
			},
			{
			  "s": "NYSE:BRK.A",
			  "d": "Berkshire Hathaway"
			},
			{
			  "s": "NASDAQ:AVGO",
			  "d": "Broadcom Inc."
			},
			{
			  "s": "NYSE:LLY",
			  "d": "Eli Lilly"
			}
		  ]
		}
	  ]
	}
	  </script>
	</div>
	<!-- TradingView Widget END -->`;
  const spxHTMLTicker = `
	<!-- TradingView Widget BEGIN -->
<div class="tradingview-widget-container">
  <div class="tradingview-widget-container__widget"></div>
  <script type="text/javascript" src="https://s3.tradingview.com/external-embedding/embed-widget-symbol-info.js" async>
  {
  "symbol": "OANDA:SPX500USD",
  "width": "100%",
  "height":"100%",
  "locale": "en",
  "colorTheme": "light",
  "isTransparent": false
}
  </script>
</div>
<!-- TradingView Widget END -->
	`;
  const spxHTMLMeter = `
	<div class="tradingview-widget-container">
	  <div class="tradingview-widget-container__widget"></div>
	  <script type="text/javascript" src="https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js" async>
	  {
	  "interval": "1D",
	  "isTransparent": false,
	  "height":"370",
	  "width":"100%",
	  "symbol": "SP:SPX",
	  "showIntervalTabs": true,
	  "locale": "en",
	  "colorTheme": "light"
	}
	  </script>
	</div>
	`;

  // 	const htmlNews = `<html><body>
  // 	<script type="text/javascript">DukascopyApplet = {"type":"online_news","params":{"header":false,"borders":false,"defaultLanguage":"en","availableLanguages":["ar","bg","cs","de","en","es","fa","fr","he","hu","it","ja","ms","pl","pt","ro","ru","sk","sv","th","uk","zh"],"newsCategories":["finance","forex","stocks","company_news","commodities"],"width":"100%","height":"500","adv":"popup"}};</script><script type="text/javascript" src="https://freeserv-static.dukascopy.com/2.0/core.js"></script>
  // </body></html>`;
  //fred iframes
  const fredInflation = `<iframe src="https://fred.stlouisfed.org/graph/graph-landing.php?g=OYov&width=100%&height=330" scrolling="no" frameborder="0" style="overflow:hidden; width:100%; height:350px;" allowTransparency="true" loading="lazy"></iframe>`;
  const fredInterestRates = `<iframe src="https://fred.stlouisfed.org/graph/graph-landing.php?g=PxTa&width=100%&height=330" scrolling="no" frameborder="0" style="overflow:hidden; width:100%; height:350px;" allowTransparency="true" loading="lazy"></iframe>`;
  const fredTreasuryYield = `<iframe src="https://fred.stlouisfed.org/graph/graph-landing.php?g=PxXI&width=100%&height=330" scrolling="no" frameborder="0" style="overflow:hidden; width:100%; height:350px;" allowTransparency="true" loading="lazy"></iframe>`;
  const fredCostPrice = `<iframe src="https://fred.stlouisfed.org/graph/graph-landing.php?g=OYuh&width=100%&height=330" scrolling="no" frameborder="0" style="overflow:hidden; width:100%; height:350px;" allowTransparency="true" loading="lazy"></iframe>`;
  const fredProducerPrice = `<iframe src="https://fred.stlouisfed.org/graph/graph-landing.php?g=OYwl&width=100%&height=330" scrolling="no" frameborder="0" style="overflow:hidden; width:100%; height:350px;" allowTransparency="true" loading="lazy"></iframe>`;
  const fredJobless = `<iframe src="https://fred.stlouisfed.org/graph/graph-landing.php?g=OYuX&width=100%&height=330" scrolling="no" frameborder="0" style="overflow:hidden; width:100%; height:350px;" allowTransparency="true" loading="lazy"></iframe>`;
  const tickerTape =
    "https://s.tradingview.com/embed-widget/ticker-tape/?locale=en#%7B%22symbols%22%3A%5B%7B%22proName%22%3A%22FOREXCOM%3ASPXUSD%22%2C%22title%22%3A%22S%26P%20500%22%7D%2C%7B%22proName%22%3A%22FOREXCOM%3ANSXUSD%22%2C%22title%22%3A%22US%20100%22%7D%2C%7B%22proName%22%3A%22FX_IDC%3AEURUSD%22%2C%22title%22%3A%22EUR%2FUSD%22%7D%2C%7B%22proName%22%3A%22BITSTAMP%3ABTCUSD%22%2C%22title%22%3A%22Bitcoin%22%7D%2C%7B%22proName%22%3A%22BITSTAMP%3AETHUSD%22%2C%22title%22%3A%22Ethereum%22%7D%5D%2C%22showSymbolLogo%22%3Atrue%2C%22colorTheme%22%3A%22light%22%2C%22isTransparent%22%3Afalse%2C%22displayMode%22%3A%22adaptive%22%2C%22width%22%3A%22100%25%22%2C%22height%22%3A78%2C%22utm_source%22%3A%22www.tradingview.com%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22ticker-tape%22%2C%22page-uri%22%3A%22www.tradingview.com%2Fwidget%2Fticker-tape%2F%22%7D";
  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle="Macroeconomics" />

      <Grid style={{ marginTop: "20px" }}>
        <Grid className="sentimentsCard centerText" item>
          <div
            style={{
              paddingTop: "18px",
            }}
          >
            <h3 className="roboto">
              Sentiments{" "}
              <InfoIcon
                onClick={() => {
                  handleInfoPop("sentiments");
                }}
                className="icon icon-popup"
              ></InfoIcon>
            </h3>
          </div>
          <Grid container style={{}} justifyContent="space-between">
            <Grid item className="dashboardCardsSentiments" style={{ maxWidth: "780px" }}>
              <div
                style={{
                  marginTop: "18px",
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                  alignItems: "center",
                }}
              >
                <p className="roboto" style={{ textAlign: "center", fontSize: "18px", marginRight: "5px" }}>
                  S&P 500
                </p>
                <InfoIcon
                  onClick={() => {
                    handleInfoPop("snp");
                  }}
                  className="icon icon-popup"
                ></InfoIcon>
              </div>
              <iframe
                className="iframeDashboard"
                style={{ width: "100%", height: "247px" }}
                title="spx ticker info"
                srcDoc={spxHTMLTicker}
              ></iframe>
              <iframe
                className="iframeDashboard spxMeter"
                style={{ width: "100%", height: "400px" }}
                title="spx meter"
                srcDoc={spxHTMLMeter}
              ></iframe>
            </Grid>
            <Grid item className="dashboardCardsSentiments">
              <div
                style={{
                  marginTop: "18px",
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                  alignItems: "center",
                }}
              >
                <p className="roboto" style={{ textAlign: "center", fontSize: "18px", marginRight: "5px" }}>
                  Fear & Greed Index
                </p>
                <InfoIcon
                  onClick={() => {
                    handleInfoPop("fearAndGreed");
                  }}
                  className="icon icon-popup"
                ></InfoIcon>
              </div>
              <div style={{ padding: "40px" }}>
                <FearGreedIndexComponent
                  lastUpdated={fearData.lastUpdated.humanDate}
                  previousClose={fearData.fgi.previousClose.value}
                  oneMonthAgo={fearData.fgi.oneMonthAgo.value}
                  oneWeekAgo={fearData.fgi.oneWeekAgo.value}
                  oneYearAgo={fearData.fgi.oneYearAgo.value}
                  fearIndex={fearData.fgi.now.value}
                ></FearGreedIndexComponent>
              </div>
              {/* <iframe className="iframeDashboard" title="spx meter" srcDoc={spxHTMLMeter}></iframe> */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      

      <Grid
        className="trend_economic_grid"
        justifyContent="space-between"
        style={{ textAlign: "center", height: "", marginTop: "20px" }}
        container
      >
        <Grid className="dashboardTrendCard" item>
          <div
            style={{
              marginTop: "18px",
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <h3 className="roboto" style={{ textAlign: "center", marginRight: "5px" }}>
              Trend
            </h3>
            <InfoIcon
              onClick={() => {
                handleInfoPop("trend");
              }}
              className="icon icon-popup"
            ></InfoIcon>
          </div>
          <Grid
            container
            justifyContent="space-between"
            style={{ textAlign: "left", marginTop: "15px", overflow: "auto" }}
          >
            <Grid item className="dashboardCardsSentiments" style={{ height: "auto" }}>
              <SectorButtons />
              <iframe
                style={{ width: "100%", height: "440px" }}
                className="iframeDashboard"
                title="indices"
                srcDoc={configureHTML()}
              ></iframe>
            </Grid>
            <Grid item className="dashboardCardsSentiments" style={{ height: "auto" }}>
              <Grid item className="dashboardCardsSectors" style={{ height: "auto" }}>
                <div style={{ marginLeft: "10px" }}>
                  <BasicMenu type="defensive" />
                </div>
                <div id="defensive-sectors" style={{ height: "400px", overflow: "auto", padding: "10px" }}>
                  {defensiveSectors.map((sector, index) => {
                    return (
                      <div key={index} id={`defensive-sectors-${sector.ticker}`} style={{ marginBottom: "15px" }}>
                        <p className="roboto_medium" style={{ paddingLeft: "10px", fontSize: "16px" }}>
                          {sector.name}
                        </p>
                        <SmallSymbolOverviewWidget exchange={sector.exchange} ticker={sector.Ticker} duration="12M" />
                      </div>
                    );
                  })}
                </div>
              </Grid>
              <Grid item className="dashboardCardsSectors" style={{ height: "auto" }}>
                <div style={{ marginLeft: "10px" }}>
                  <BasicMenu type="cyclical" />
                </div>
                <div id="cyclical-sectors" style={{ height: "400px", overflow: "auto", padding: "10px" }}>
                  {cyclicalSectors.map((sector, index) => {
                    return (
                      <div key={index} id={`cyclical-sectors-${sector.ticker}`} style={{ marginBottom: "15px" }}>
                        <p className="roboto_medium" style={{ paddingLeft: "10px", fontSize: "16px" }}>
                          {sector.name}
                        </p>
                        <SmallSymbolOverviewWidget exchange={sector.exchange} ticker={sector.Ticker} duration="12M" />
                      </div>
                    );
                  })}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        className="news_sentiment_grid"
        justifyContent="space-between"
        style={{ textAlign: "center", marginTop: "20px" }}
        container
      >
        <Grid className="dashboardCardsLg newsGrid" style={{ backgroundColor: "white", borderRadius: "15px" }} item>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <h3 className="roboto" style={{ textAlign: "center", marginRight: "5px" }}>
              News
            </h3>
            <InfoIcon
              onClick={() => {
                handleInfoPop("news");
              }}
              className="icon icon-popup"
            ></InfoIcon>
          </div>
          <NewsButtons />
          <NewsTable category={newsCategory} data={newsData} />
          {/* <iframe className="newsIframe iframeDashboard " srcDoc={htmlNews} title="efa"></iframe> */}
        </Grid>
        <Grid className="dashboardCardsSpecialSmOne economicCalendar" item>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <h3 className="roboto" style={{ textAlign: "center", marginRight: "5px" }}>
              Economic Calendar
            </h3>
            <InfoIcon
              onClick={() => {
                handleInfoPop("economicCalender");
              }}
              className="icon icon-popup"
            ></InfoIcon>
          </div>
          <EconomicCalendar />
        </Grid>
      </Grid>
      <Grid container>
        <Grid className="dashboardsCardsFull" style={{ background: "none" }} item>
          <div
            style={{
              marginTop: "18px",
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <h3 className="roboto" style={{ textAlign: "center", marginRight: "5px" }}>
              Key Year Events
            </h3>
          </div>
          <KeyYearEvents />
        </Grid>
      </Grid>
      <Grid className="dashboardsCardsFull portfolioCard" style={{ overflowX: "auto", overflowY: "hidden" }} item>
        {/* <p className="roboto" style={{ fontSize: "18px", paddingTop: "18px",paddingLeft:'20px' }}>
						Portfolio
					</p>
					<div style={{ backgroundColor: "white", borderRadius: "16px" }}>
						<div className="portfolioHeader"></div>
						<div className="portfolioDiv">
							<img src={rocketImg} alt="wrench" />
							<p className="helvetica inline " style={{ fontSize: "14px", paddingLeft: "15px" }}>
								Total Stocks <br></br>
								<span className="portfolioAmt">250 in stock</span>{" "}
							</p>
							<span></span>
							<ChevronRightIcon />
						</div>
						<div className="portfolioDiv">
							<img src={wrenchImg} alt="wrench" />
							<p className="helvetica inline" style={{ fontSize: "14px", paddingLeft: "15px" }}>
								Total Options <br></br> <span className="portfolioAmt">250 in stock</span>
							</p>
							<span></span>
							<ChevronRightIcon />
						</div>
						<div className="portfolioDiv">
							<img src={cryptoImg} alt="crpyto" />
							<p className="helvetica inline" style={{ fontSize: "14px", paddingLeft: "15px" }}>
								Total Crypto <br></br>
								<span className="portfolioAmt">250 in stock</span>
							</p>
							<span></span>
							<ChevronRightIcon />
						</div>
					</div> */}
        <div
          style={{
            marginBottom: "40px",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
          }}
        >
          <h3 className="roboto" style={{ textAlign: "center", marginRight: "5px" }}>
            Macro Economics
          </h3>
          <InfoIcon
            onClick={() => {
              handleInfoPop("macroEconomic");
            }}
            className="icon icon-popup"
          ></InfoIcon>
        </div>
        <div>
          <div
            className="fredChartsContainer"
            style={{ display: "flex", justifyContent: "space-evenly", flexWrap: "wrap" }}
          >
            <div style={{ minHeight: "420px" }}>
              <div className="iframeText">
                <div className="Dot" />
                <p style={{ display: "inline-block", marginLeft: "5px", fontSize: "16px" }}>Inflation</p>
              </div>
              <iframe className="iframeDashboard fredIframe" title="economic calendar" srcDoc={fredInflation}></iframe>
            </div>
            <div style={{ minHeight: "420px" }}>
              <div className="iframeText">
                <div className="Dot" />
                <p style={{ display: "inline-block", marginLeft: "5px", fontSize: "16px" }}>Interest Rates</p>
              </div>
              <iframe
                className="iframeDashboard fredIframe"
                title="economic calendar"
                srcDoc={fredInterestRates}
              ></iframe>
            </div>
            <div style={{ minHeight: "420px" }}>
              <div className="iframeText">
                <div className="Dot" />
                <p style={{ display: "inline-block", marginLeft: "5px", fontSize: "16px" }}>Treasury Yields</p>
              </div>
              <iframe
                className="iframeDashboard fredIframe"
                title="economic calendar"
                srcDoc={fredTreasuryYield}
              ></iframe>
            </div>
          </div>
        </div>
        <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <hr class="dashed" style={{ marginBottom: "20px" }}></hr>
        </div>
        <div>
          <div
            className="fredChartsContainer"
            style={{ display: "flex", justifyContent: "space-evenly", flexWrap: "wrap" }}
          >
            <div style={{ minHeight: "420px" }}>
              <div className="iframeText">
                <div className="Dot" />
                <p style={{ display: "inline-block", marginLeft: "5px", fontSize: "16px" }}>Cost Price Index</p>
              </div>
              <iframe className="iframeDashboard fredIframe" title="economic calendar" srcDoc={fredCostPrice}></iframe>
            </div>
            <div style={{ minHeight: "420px" }}>
              <div className="iframeText">
                <div className="Dot" />
                <p style={{ display: "inline-block", marginLeft: "5px", fontSize: "16px" }}>Producer Price Index</p>
              </div>
              <iframe
                className="iframeDashboard fredIframe"
                title="economic calendar"
                srcDoc={fredProducerPrice}
              ></iframe>
            </div>
            <div style={{ minHeight: "420px" }}>
              <div className="iframeText">
                <div className="Dot" />
                <p style={{ display: "inline-block", marginLeft: "5px", fontSize: "16px" }}>Jobless Claims</p>
              </div>
              <iframe className="iframeDashboard fredIframe" title="economic calendar" srcDoc={fredJobless}></iframe>
            </div>
          </div>
        </div>
      </Grid>
      <Grid container mb={3}>
        <Grid className="dashboardsCardsFull" item>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              alignItems: "center",
			  marginTop: "16px"
            }}
          >
            <h3 className="roboto" style={{ textAlign: "center", marginRight: "5px" }}>
              Seasonality
            </h3>
            <InfoIcon
              onClick={() => {
                handleInfoPop("seasonality");
              }}
              className="icon icon-popup"
            ></InfoIcon>
          </div>
		  <SeasonalityBlock />
        </Grid>
      </Grid>

      {infoPopup ? <DashboardInfoPopup toggleInfoPopup={toggleInfoPopup} popupAccessor={popupAccessor} /> : <div></div>}
    </DashboardLayout>
  );
}

export default Default;
